import { render, staticRenderFns } from "./RedirectEmployers.vue?vue&type=template&id=42d99b00&"
import script from "./RedirectEmployers.vue?vue&type=script&lang=js&"
export * from "./RedirectEmployers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports